export default {
  packingLists: [],
  packingList: undefined,
};
